import { useEffect } from "react";
import evEnums from "@/enums";
import usePersistedBoundStore from "@/store/persisted-bound-store";
import type { RealmSliceState } from "@/store/realm-slice";

/**
 * Custom hook that sets the realm to "evbasic" when the component is mounted
 * and restores it to "evcore" when the user leaves the page (beforeunload) or
 * when the component is unmounted.
 */
export default function useEvbasicRealm() {
  const setRealm = usePersistedBoundStore.use.setRealm();

  useEffect(() => {
    setRealm(evEnums.SECURITY.RealmEnum.EVBASIC.Label as RealmSliceState["realm"]);

    const handleBeforeUnload = () => {
      setRealm(evEnums.SECURITY.RealmEnum.EVCORE.Label as RealmSliceState["realm"]);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [setRealm]);
}
